import React, { useState } from 'react';
import './styles.scss';
import Button from './../buttons/Button';
import { withRouter  } from "react-router-dom";

const Cookies = (props) => {
    let [ accepted, setAccepted ] = useState(false)
    const setCookie = () => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('cookie', 'Zaakceptowana polityka Cookie');
            setAccepted(true);
        }
    }
    if(typeof window !== "undefined") {
        let link = document.getElementById('cookies-link');
        if(link) {
            // link.addEventListener('click', function(e) {
            //     e.preventDefault();
            //     let href = e.target.getAttribute('href');
            //     props.history.push(href);
            // });
            const callback = (e) => {
                e.preventDefault();
                let href = e.target.getAttribute('href');
                props.history.push(href);
            }

            link.addEventListener('click', function(e) {
                callback(e)
            });

            link.addEventListener('touchstart', function(e) {
                callback(e)
            });
        }
    }
    return (
        <>
            { props.visible && !accepted && 
                <div className="cookie-info">
                    <div dangerouslySetInnerHTML={{ __html: `${props.cookieText}` }} />
                    <div className="button-wrap">
                        {/* <button onClick={() => setCookie() }>Akceptuj</button> */}
                        <Button title="Zgoda" class="blue-cookies" arrow={ true }  setFunction={ () => setCookie() } />
                    </div>
                </div>
            }
        </>
    );
}

export default withRouter(Cookies);